import React from "react";
import { withTranslation } from "react-i18next";
import { Form, DatePicker, Typography } from "antd";
import moment from "moment";
import styled from "styled-components";

import { SEC_FONT_GREY } from "../../constant/colors";

const { Text } = Typography;

const FormItemStyled = styled(Form.Item)`
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
    &::before {
      display: none;
    }
    &::after {
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      content: "*";
      color: ${SEC_FONT_GREY};
    }
  }
`;

const AdminDateFormItemComponent = ({
  t,
  style,
  required = false,
  editable = true,
  showLabel = false,
  strong = false,
  disabled = false,
  defaultValue,
  dataTMId,
  name = "administrationDate",
  recordInfo
}) => {
  const momentDefaultValue = defaultValue ? moment(defaultValue) : null;

  return (
    <FormItemStyled
      name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
      label={
        showLabel ? (
          <Text strong={strong} style={{ color: "#9B9B9B" }}>
            {t("form.admin_date.label")}
          </Text>
        ) : null
      }
      style={style}
      colon={false}
      rules={[{ required, message: t("form.admin_date.error_required") }]}
    >
      {editable ? (
        <DatePicker
          style={{ width: "100%" }}
          placeholder={t("form.admin_date.placeholder")}
          disabled={disabled || !editable}
          format={"MM/DD/YYYY"}
          allowClear={true}
          data-tm-id={dataTMId}
          defaultValue={momentDefaultValue}
        />
      ) : (
        <Text data-tm-id={dataTMId}>{defaultValue ? `${moment(defaultValue).format("MM/DD/YYYY")}` : "-"}</Text>
      )}
    </FormItemStyled>
  );
};

const AdminDateFormItem = withTranslation()(AdminDateFormItemComponent);

export { AdminDateFormItem };
